var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 1.24835L13.5967 37.18C13.2648 37.6569 12.8243 38.0481 12.3116 38.3214C11.7989 38.5946 11.2286 38.7421 10.6477 38.7517C10.0668 38.7613 9.49187 38.6328 8.9704 38.3766C8.44892 38.1204 7.99579 37.744 7.64833 37.2784L1.25 28.7484",
    stroke: "#39B54A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidGreen);
export default __webpack_public_path__ + "static/media/valid_green.59371af50fe7982be4b3d1ede77aa0b1.svg";
export { ForwardRef as ReactComponent };